import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-1a072af1"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "detail"
};
var _hoisted_2 = {
  class: "content"
};
var _hoisted_3 = {
  class: "message"
};
var _hoisted_4 = {
  class: "book_img"
};
var _hoisted_5 = ["src"];
var _hoisted_6 = {
  class: "right"
};
var _hoisted_7 = {
  class: "bookTitle"
};
var _hoisted_8 = {
  class: "bookTime"
};
var _hoisted_9 = {
  class: "bookTime"
};
var _hoisted_10 = {
  class: "bookClass"
};
var _hoisted_11 = {
  class: "master"
};

var _hoisted_12 = /*#__PURE__*/_createTextVNode(" 开始阅读 ");

var _hoisted_13 = /*#__PURE__*/_createTextVNode(" 继续阅读 ");

var _hoisted_14 = /*#__PURE__*/_createTextVNode(" 加入书架 ");

var _hoisted_15 = /*#__PURE__*/_createTextVNode(" 已在书架 ");

var _hoisted_16 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "header space"
  }, " 简介: ", -1);
});

var _hoisted_17 = ["innerHTML"];
var _hoisted_18 = {
  key: 1
};
var _hoisted_19 = {
  key: 0,
  style: {
    "padding-top": "13px"
  },
  class: "readProgress"
};

var _hoisted_20 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, null, -1);
});

var _hoisted_21 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "spanLeft"
  }, " 您已读至 ", -1);
});

var _hoisted_22 = {
  class: "spancenter"
};

var _hoisted_23 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, null, -1);
});

var _hoisted_24 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "header space"
  }, " 目录: ", -1);
});

var _hoisted_25 = {
  class: "chapter"
};
var _hoisted_26 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Head = _resolveComponent("Head");

  var _component_el_button = _resolveComponent("el-button");

  var _component_el_col = _resolveComponent("el-col");

  var _component_el_row = _resolveComponent("el-row");

  var _component_ArrowRight = _resolveComponent("ArrowRight");

  var _component_el_icon = _resolveComponent("el-icon");

  var _component_el_pagination = _resolveComponent("el-pagination");

  var _directive_debounce = _resolveDirective("debounce");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_Head, {
    title: "书籍详情",
    back: true
  }), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_ctx.detail.data.coverPic ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    src: _ctx.baseurl + _ctx.detail.data.coverPic
  }, null, 8, _hoisted_5)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.detail.data.bookName), 1), _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.detail.data.author) + " 著 ", 1), _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.detail.data.createTime), 1), _createElementVNode("div", _hoisted_10, [_createElementVNode("span", null, _toDisplayString(_ctx.detail.data.typeName), 1)]), _createElementVNode("div", _hoisted_11, [_ctx.detail.chapterIndex == 0 ? (_openBlock(), _createBlock(_component_el_button, {
    key: 0,
    size: "medium",
    class: "btnSign",
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return _ctx.beginRead(1);
    })
  }, {
    default: _withCtx(function () {
      return [_hoisted_12];
    }),
    _: 1
  })) : _createCommentVNode("", true), _ctx.detail.chapterIndex != 0 ? (_openBlock(), _createBlock(_component_el_button, {
    key: 1,
    size: "medium",
    class: "btnSign",
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return _ctx.goRead(_ctx.detail.chapterIndex);
    })
  }, {
    default: _withCtx(function () {
      return [_hoisted_13];
    }),
    _: 1
  })) : _createCommentVNode("", true), _ctx.detail.collect == 0 ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
    key: 2,
    size: "medium",
    class: "btnSign",
    onClick: _cache[2] || (_cache[2] = function ($event) {
      return _ctx.joinBookCase(_ctx.detail.data.bookId);
    })
  }, {
    default: _withCtx(function () {
      return [_hoisted_14];
    }),
    _: 1
  }, 512)), [[_directive_debounce]]) : _createCommentVNode("", true), _ctx.detail.collect == 1 ? (_openBlock(), _createBlock(_component_el_button, {
    key: 3,
    size: "medium",
    class: "btnSign",
    style: {
      "color": "#a6a6a6",
      "border-color": "#a6a6a6"
    },
    onClick: _cache[3] || (_cache[3] = function ($event) {
      return _ctx.joinBookCasedel(_ctx.detail.data.bookId);
    })
  }, {
    default: _withCtx(function () {
      return [_hoisted_15];
    }),
    _: 1
  })) : _createCommentVNode("", true)])])]), _createVNode(_component_el_row, {
    style: {
      "padding-top": "13px",
      "border-bottom": "none"
    },
    class: "b-btm"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_col, {
        span: 24
      }, {
        default: _withCtx(function () {
          return [_hoisted_16, _ctx.detail.data.abstracted ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "space",
            innerHTML: _ctx.detail.data.abstracted
          }, null, 8, _hoisted_17)) : (_openBlock(), _createElementBlock("div", _hoisted_18, " 无 "))];
        }),
        _: 1
      })];
    }),
    _: 1
  }), _ctx.detail.chapterIndex != 0 ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_hoisted_20, _createElementVNode("div", {
    class: "isRead",
    onClick: _cache[4] || (_cache[4] = function ($event) {
      return _ctx.goRead(_ctx.detail.chapterIndex);
    })
  }, [_hoisted_21, _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.detail.chapterName), 1), _createVNode(_component_el_icon, null, {
    default: _withCtx(function () {
      return [_createVNode(_component_ArrowRight)];
    }),
    _: 1
  })]), _hoisted_23])) : _createCommentVNode("", true), _createVNode(_component_el_row, {
    style: {
      "padding-top": "13px",
      "border-bottom": "none"
    },
    class: "b-btm"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_col, {
        span: 24
      }, {
        default: _withCtx(function () {
          return [_hoisted_24, _createElementVNode("div", _hoisted_25, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail.chapter, function (item, index) {
            return _openBlock(), _createElementBlock("div", {
              key: index,
              class: "item",
              onClick: function onClick($event) {
                return _ctx.goRead(item.chapterId);
              }
            }, _toDisplayString(item.chapterName), 9, _hoisted_26);
          }), 128))])];
        }),
        _: 1
      })];
    }),
    _: 1
  }), _createVNode(_component_el_pagination, {
    background: "",
    layout: "prev, pager, next",
    total: _ctx.detail.totalNum,
    class: "pagination",
    "page-size": 10,
    "current-page": _ctx.detail.currentPage,
    onCurrentChange: _ctx.changPage
  }, null, 8, ["total", "current-page", "onCurrentChange"])])])], 64);
}